import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';
import Cart from './pages/Cart/Cart';
import PlaceOrder from './pages/PlaceOrder/PlaceOrder';

function App() {
  const router=createBrowserRouter([
    {
      path:'/',
      element:<Home/>
    },
    {
      path:"/cart",
      element:<Cart/>
    },
    {
      path:"/placeorder",
      element:<PlaceOrder/>
    }
  ])
  return (
    
    <div className="App">
      <RouterProvider router={router}/>
    </div>
  );
}

export default App;
